import {
  login, getUserInfo, getUserList, saveUser, putRecharge, getRecharge, rechargePage, ConsumptionRecord,
  SaveDispenseAccount, GetDispenseAccount, InitPWD, UserConsumptionRecord, GetSettle, userCompany, ClearUserMoney, SendUserCoupon, RechargeRfund, GetUserInfo, GetXiaoXianTeacherInfo, CreateUserStaff, GetUserStaffInfo, BindStaffCard,GetStaffCards,UnbindCard
} from '@/api/user'
import { Notice } from "iview";
import router from '@/router'
import { setToken, getToken, canTurnTo } from '@/libs/util'
let connSocket = (commit, self) => {
  let socket
  if (getToken()) {
    // socket = new WebSocket(`wss://socket.aidprint.com/websocket?token=${getToken()}`)
    // socket = new WebSocket(`${process.env.NODE_ENV === "development" ? 'wss://school-ws.aidprint.com' : 'wss://school-ws.aidprint.com'}/websocket?token=${getToken()}`)
    socket = new WebSocket(`${process.env.NODE_ENV === "development" ? 'ws://192.168.0.193:4021' : 'wss://school-ws.aidprint.com'}/websocket?token=${getToken()}`)
  }
  socket.onopen = () => {
    commit('SET_SOCKET', socket)
  }
  setInterval(() => {
    if (socket) {
      try {
        socket.send(JSON.stringify({ "action": 10001 }))
      } catch (e) {
        console.log('发送心跳错误')
      }
    }
  }, 5000)
  socket.onclose = () => {
    setTimeout(() => {
      connSocket(commit, self)
    }, 2000)
  }
  socket.onmessage = (e) => {
    let data = JSON.parse(e.data)
    switch (data.action) {
      // 成功提示
      case 10000: break
      // 错误提示
      case 10001: break
      // 设备状态
      case 10002:
        self.state.machine.machine.map(item => {
          item.machine_status = data.data[item.sn]
        })
        break
      // 设备连接与断开
      case 10003:
        self.state.machine.machine.map(item => {
          if (data.id) {
            if (item.id === data.id) {
              item.machine_status = data.machine_status
            }
          } else if (data.sn) {
            if (item.sn === data.sn) {
              item.machine_status = data.machine_status
            }
          }

        })
        break
      // 获取设备信息
      case 10004:
        if (data.value) {
          let nameObj = {
            black: "黑色",
            magenta: "红色",
            yellow: "黄色",
            cyan: "青色",
            manual: "手送台",
            tray1: "纸盒1",
            tray2: "纸盒2",
            tray3: "纸盒3",
            tray4: "纸盒4"
          };
          let tray = [],
            toner = []
          data.value.tray.map(item => {
            tray.push({
              name: nameObj[item.split('_')[0]],
              val: parseInt(item.split('_')[1])
            })
          })
          data.value.toner.map(item => {
            toner.push({
              name: nameObj[item.split('_')[0]],
              val: parseInt(item.split('_')[1])
            })
          })
          data.value.tray = tray
          data.value.toner = toner
          self.state.machine.machine_info = data.value
        }
        break
      case 10008:
        console.log(data)
        self.state.machine.machine.map(item => {
          if (item.id === data.machine_id) {
            item.error = data.error
          }
        })
        console.log(self.state.machine.machine)
        break;
      case 10009:
        self.state.machine.machine.map(item => {
          if (data.data && item.sn === data.data.sn) item.machine_status = data.data.machine_status;
          if (data.value && item.sn === data.value.sn) item.machine_status = data.value.machine_status;
          if (data.sn && item.sn === data.sn) item.machine_status = data.machine_status;
        })
        break
      case 2020:
        let noticeData = {
          title: '抄表数据获取成功',
          duration: 0
        }
        if (router.currentRoute.name === 'meter-log') {
          self.state.user.meterLog = !self.state.user.meterLog
          noticeData.desc = '数据已刷新'
        } else {
          noticeData.render = h => {
            return h('span', [
              '点击',
              h('a', {
                on: {
                  click: function () {
                    router.push({ name: "meter-log" })
                  }
                }
              }, '此处'),
              '跳转至抄表记录查看'
            ])
          }
        }
        Notice.success(noticeData);
        break;
      default:
        break
    }
  }
}
export default {
  state: {
    agent: {},
    access: [],
    socket: {},
    token: getToken(),
    meterLog: true,
    role: []
  },
  getters: {
    agent: state => state.agent,
    access: state => state.access,
    socket: state => state.socket,
    meterLog: state => state.meterLog,
    role: state => state.role
  },
  actions: {
    FalseUpdPWD({ commit }, payload) {
      commit("FALSEUPDPWD", false)
    },
    // socket 发送消息
    socketSend({ commit }, payload) {
      try {
        this.state.user.socket.send(JSON.stringify(payload))
      } catch (error) {

      }
    },
    // 登录
    handleLogin({ commit }, { code, password }) {
      code = code.trim()
      return new Promise((resolve, reject) => {
        login({ code, password }).then(res => {
          if (res.data.status) {
            commit('SET_AGENT', res.data.data)
            setToken(res.data.token)
            connSocket(commit, this)
          }
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut({ state, commit }) {
      setToken('')
    },
    // 获取用户相关信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo().then(res => {
            if (res.data) {
              connSocket(commit, this)
              commit('SET_AGENT', res.data)
              if (res.data.role) {
                commit('SET_ROLE', res.data.role)
              }
              // socket
            } else {
              setToken('')
            }
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 获取会员列表
    getUsers({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          getUserList(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 保存 新增 用户
    putUser({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          saveUser(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 充值
    rechargeDo({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          putRecharge(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 查询充值
    userRecharge({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          getRecharge(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 充值列表
    rechargeList({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          rechargePage(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 消费记录
    ConsumptionRecord({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          ConsumptionRecord(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 保存分账账号
    GetDispenseAccount({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          GetDispenseAccount(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 保存分账账号
    SaveDispenseAccount({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          SaveDispenseAccount(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    InitPWD({ commit }, payload) {
      return new Promise(resolve => {
        InitPWD(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    UserConsumptionRecord({ commit }, payload) {
      return new Promise(resolve => {
        UserConsumptionRecord(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    userCompany({ commit }, payload) {
      return new Promise(resolve => {
        userCompany(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    ClearUserMoney({ commit }, payload) {
      return new Promise(resolve => {
        ClearUserMoney(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SendUserCoupon({ commit }, payload) {
      return new Promise(resolve => {
        SendUserCoupon(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    RechargeRfund({ commit }, payload) {
      return new Promise(resolve => {
        RechargeRfund(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetUserInfo({ commit }, payload) {
      return new Promise(resolve => {
        GetUserInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetXiaoXianTeacherInfo({ commit }, payload) {
      return new Promise(resolve => {
        GetXiaoXianTeacherInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CreateUserStaff({ commit }, payload) {
      return new Promise(resolve => {
        CreateUserStaff(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetUserStaffInfo({ commit }, payload) {
      return new Promise(resolve => {
        GetUserStaffInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    BindStaffCard({ commit }, payload) {
      return new Promise(resolve => {
        BindStaffCard(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetStaffCards({ commit }, payload) {
      return new Promise(resolve => {
        GetStaffCards(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    UnbindCard({ commit }, payload) {
      return new Promise(resolve => {
        UnbindCard(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  mutations: {
    SET_AGENT(state, payload) {
      state.access = [`${payload.tp}`]
      state.agent = payload
    },
    SET_SOCKET(state, payload) {
      state.socket = payload
    },
    FALSEUPDPWD(state, payload) {
      state.agent.update_password = false
    },
    SET_ROLE(state, payload) {
      state.role = payload.params.split(',');
    }
  }
}
